import { useEffect, RefObject } from "react";

export const useClickOutside = (ref: RefObject<HTMLElement>, onCallback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && e.target && !ref.current.contains(e.target as Node)) {
        onCallback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onCallback, ref]);
};
